import Font from '@maxpreps/shared/styles/font';
import React from 'react';
import SmartAnchor from '../../corecomponents/Anchor/SmartAnchor';
import {
  IAsAnchorOptions,
  IAsButtonOptions,
  IConfigurableLink
} from '../../models/configurableLink';
import THEME, { COLOR } from '../../styles/colors';
import StyledButton, { ButtonFill, ButtonTheme } from '../Button/StyledButton';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';
import Modal from '../Modal/Modal';
import StyledText from '../Text/StyledText';
import {
  StyledAlert,
  StyledLinksWrapper,
  StyledTextWrapper
} from './StyledAlert';

export interface IAlertLink
  extends Omit<IConfigurableLink, 'icon' | 'isDisabled' | 'isActive'> {
  colorScheme?: ButtonTheme;
  isLoading?: boolean;
  text: string;
}

export const LOADING_OPTION: IAlertLink = {
  text: '',
  isLoading: true,
  as: 'button'
};

interface IAlertProps {
  title: string;
  subTitle?: string;
  links: IAlertLink[];
  onOutClick: any;
}

const getButtonOrAnchor = (item: IAlertLink) => {
  const content = item.isLoading ? <LoadingSpinner size={16} /> : item.text;
  const styleProps = {
    $fillMode: ButtonFill.Link,
    $colorScheme: item.colorScheme ?? ButtonTheme.Link
  };

  if (item.as === 'a') {
    const { anchorComponent, ...anchorProps } =
      item.asOptions as IAsAnchorOptions;

    const Tag = anchorComponent ?? SmartAnchor;

    return (
      <Tag
        key={item.text}
        visualComponent={StyledButton}
        visualComponentProps={styleProps}
        {...anchorProps}
      >
        {content}
      </Tag>
    );
  }
  if (item.as === 'button') {
    const onClick = item.asOptions?.onClick as IAsButtonOptions;

    return (
      <StyledButton key={item.text} onClick={onClick} {...styleProps}>
        {content}
      </StyledButton>
    );
  }
  return null;
};

const Alert: React.FC<IAlertProps> = ({
  title,
  subTitle,
  links,
  onOutClick
}) => (
  <Modal onOutClick={onOutClick} maxWidth="400px" portalId={`alert_${title}`}>
    <StyledAlert>
      <StyledTextWrapper>
        <StyledText className={Font.f16_bold_tall} $color={THEME.text.primary}>
          {title}
        </StyledText>
        {subTitle && (
          <StyledText className={Font.f16_tall} $color={COLOR.neutral60}>
            {subTitle}
          </StyledText>
        )}
      </StyledTextWrapper>
      <StyledLinksWrapper>{links.map(getButtonOrAnchor)}</StyledLinksWrapper>
    </StyledAlert>
  </Modal>
);

export default Alert;
